'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z' });

var PhotoSizeSelectSmall = function PhotoSizeSelectSmall(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PhotoSizeSelectSmall = (0, _pure2.default)(PhotoSizeSelectSmall);
PhotoSizeSelectSmall.muiName = 'SvgIcon';

exports.default = PhotoSizeSelectSmall;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PhotoSizeSelectSmall.js
// module id = 2716
// module chunks = 0